import {useQuery} from '@tanstack/react-query'
import {NexusService} from 'global-apis/nexus-service'
import {useState} from 'react'
import { map } from 'lodash'
import { useQueryParams, withDefault, StringParam } from 'use-query-params'
import {
  getFormattedAppointmentDays,
  getAppointmentsFromCurrentDate
} from './utils'
import { ListDealershipsResponse } from '@nxcr-org/web-api-interface/lib/dealership_service_pb'

const NXCRDealershipID = 'b1d68de5-0f55-4470-9030-a5d3d7b3d84b'

export const useTasks = () => {
  const [createAppointmentModalIsVisible, setCreateAppointmentModalIsVisible] = useState(false)
  const [{ dealershipId }, setQueryParams] = useQueryParams({
    dealershipId: withDefault(
      StringParam,
      NXCRDealershipID
    ),
  })

  const {
    data: dealershipOptions
  } = useQuery({
    queryKey: ['/listDealerships'],
    queryFn: async () => {
      const dealershipResponse = await NexusService.listDealerships()
      return handleDealerships(dealershipResponse)
    },
    placeholderData: []
  })

  const { data: appointments } = useQuery({
    queryKey: ['/listAppointments', '/listAppointmentsByAccountNumber', dealershipId],
    queryFn: async () => {
      const response = await NexusService.listAppointments({
        dealershipId
      })
      return getAppointmentsFromCurrentDate(
        getFormattedAppointmentDays(response.appointmentDaysList)
      )
    }
  })

  const selectDealership = (dealershipId: string) => {
    setQueryParams({
      dealershipId,
    })
  }

  function handleClose() {
    setCreateAppointmentModalIsVisible(false)
  }

  return {
    dealershipOptions,
    dealershipId,
    appointments,
    selectDealership,
    createAppointmentModalIsVisible,
    setCreateAppointmentModalIsVisible,
    handleClose,
  }
}

export function handleDealerships(dealershipResponse: ListDealershipsResponse.AsObject){
  return map(dealershipResponse.dealersList, (dealership) => {
    return {
      label: dealership.name,
      value: dealership.id,
    }
  })
}
